import Plausible from "plausible-tracker";

const plausibleInstance = Plausible({
  domain: process.env.REACT_APP_PLAUSIBLE_DATA_DOMAIN,
  trackLocalhost: false,
});
export default plausibleInstance;
